// JDG Tempur-Pedic Adapt Collection JS
(function() {

  // Standardized UI labels: Twin, Twin XL, Full, Queen, King, Cal King, Split King, Split CA King
  // Each variant maps to the actual Shopify variant ID even if Shopify uses different label
  var PRODUCTS = {
    adapt: {
      title:    'TEMPUR-Adapt®',
      handle:   'tempur-pedic-tempur-adapt®-mattress',
      priceFrom: 1699,
      variants: {
        'Twin|Medium':           { id: '53212292153455', price: 1699 },
        'Twin|Firm':             { id: '53212292186223', price: 1699 },
        'Twin XL|Medium':        { id: '53212292448367', price: 1699 },
        'Twin XL|Firm':          { id: '53212292481135', price: 1699 },
        'Full|Medium':           { id: '53212292218991', price: 2049 },
        'Full|Firm':             { id: '53212292251759', price: 2049 },
        'Queen|Medium':          { id: '53069000114287', price: 2199 },
        'Queen|Firm':            { id: '53069000147055', price: 2199 },
        'King|Medium':           { id: '53069000179823', price: 2899 },
        'King|Firm':             { id: '53069000212591', price: 2899 },
        'Cal King|Medium':       { id: '53212292513903', price: 3399 },
        'Cal King|Firm':         { id: '53212292546671', price: 3399 },
        'Split CA King|Medium':  { id: '53212292579439', price: 3399 },
        'Split CA King|Firm':    { id: '53212292612207', price: 3399 }
      },
      feels: ['Medium','Firm'],
      sizes: ['Twin','Twin XL','Full','Queen','King','Cal King','Split CA King']
    },
    proadapt: {
      title:    'TEMPUR-ProAdapt®',
      handle:   'tempur-pedic-tempur-proadapt®-mattress',
      priceFrom: 2699,
      variants: {
        'Twin XL|Medium':              { id: '53069002801263', price: 2699 },
        'Twin XL|Firm':                { id: '53069002834031', price: 2699 },
        'Full|Medium':                 { id: '53212301492335', price: 2699 },
        'Full|Firm':                   { id: '53212301525103', price: 2699 },
        'Full|Soft':                   { id: '53212301557871', price: 2699 },
        'Full|Medium Hybrid':          { id: '53212301590639', price: 2699 },
        'Queen|Soft':                  { id: '53069002866799', price: 3399 },
        'Queen|Medium':                { id: '53069002899567', price: 3399 },
        'Queen|Medium Hybrid':         { id: '53069002932335', price: 3399 },
        'Queen|Firm':                  { id: '53069002965103', price: 3399 },
        'King|Soft':                   { id: '53069002997871', price: 4099 },
        'King|Medium':                 { id: '53069003030639', price: 4099 },
        'King|Firm':                   { id: '53069003063407', price: 4099 },
        'Cal King|Medium':             { id: '53069003096175', price: 4099 },
        'Cal King|Firm':               { id: '53069003128943', price: 4099 },
        'Split King|Medium':           { id: '53212301623407', price: 5798 },
        'Split King|Firm':             { id: '53212301656175', price: 5798 },
        'Split King|Soft':             { id: '53212301688943', price: 5798 },
        'Split King|Medium Hybrid':    { id: '53212301721711', price: 5798 },
        'Split CA King|Medium':        { id: '53212301754479', price: 5798 },
        'Split CA King|Firm':          { id: '53212301787247', price: 5798 },
        'Split CA King|Soft':          { id: '53212301820015', price: 5798 },
        'Split CA King|Medium Hybrid': { id: '53212301852783', price: 5798 }
      },
      feels: ['Soft','Medium','Medium Hybrid','Firm'],
      sizes: ['Twin XL','Full','Queen','King','Cal King','Split King','Split CA King']
    },
    luxadapt: {
      title:    'TEMPUR-LuxeAdapt®',
      handle:   'tempur-pedic-tempur-luxadapt®-mattress',
      priceFrom: 4199,
      variants: {
        'Twin XL|Soft':                { id: '53102782709871', price: 4199 },
        'Twin XL|Firm':                { id: '53102782677103', price: 4199 },
        'Twin XL|Medium Hybrid':       { id: '53102782742639', price: 4199 },
        'Queen|Soft':                  { id: '53102783004783', price: 4699 },
        'Queen|Firm':                  { id: '53102782972015', price: 4699 },
        'Queen|Medium Hybrid':         { id: '53102783037551', price: 4699 },
        'King|Soft':                   { id: '53102782513263', price: 5399 },
        'King|Firm':                   { id: '53102782480495', price: 5399 },
        'King|Medium Hybrid':          { id: '53102782546031', price: 5399 },
        'Cal King|Soft':               { id: '53102782611567', price: 5399 },
        'Cal King|Firm':               { id: '53102782578799', price: 5399 },
        'Cal King|Medium Hybrid':      { id: '53102782644335', price: 5399 },
        'Split King|Soft':             { id: '53102782808175', price: 8398 },
        'Split King|Firm':             { id: '53102782775407', price: 8398 },
        'Split King|Medium Hybrid':    { id: '53102782840943', price: 8398 },
        'Split CA King|Soft':          { id: '53102782906479', price: 8398 },
        'Split CA King|Firm':          { id: '53102782873711', price: 8398 },
        'Split CA King|Medium Hybrid': { id: '53102782939247', price: 8398 }
      },
      feels: ['Soft','Medium Hybrid','Firm'],
      sizes: ['Twin XL','Queen','King','Cal King','Split King','Split CA King']
    }
  };

  var currentModel = 'adapt';
  var currentSize  = 'Queen';
  var currentFeel  = 'Medium';

  function fmt(p) { return '$' + p.toLocaleString('en-US'); }

  function getVariant() {
    var pr = PRODUCTS[currentModel];
    return pr.variants[currentSize + '|' + currentFeel] || null;
  }

  function updatePrice() {
    var v  = getVariant();
    var pr = PRODUCTS[currentModel];
    var pe = document.getElementById('jdg-adapt-price');
    var ne = document.getElementById('jdg-adapt-price-note');
    if (!pe) return;
    pe.textContent = v ? fmt(v.price) : 'From ' + fmt(pr.priceFrom);
    ne.textContent = v ? currentSize + ' · ' + currentFeel : 'Select size & feel above';
  }
function updateButtons() {
    var v        = getVariant();
    var pr       = PRODUCTS[currentModel];
    var viewBtn  = document.getElementById('jdg-adapt-view-btn');
    var cartForm = document.getElementById('jdg-adapt-cart-form');
    var vidInput = document.getElementById('jdg-adapt-vid');

    if (viewBtn) {
      viewBtn.href = v ? '/products/' + pr.handle + '?variant=' + v.id : '/products/' + pr.handle;
    }
    if (cartForm && vidInput) {
      if (v && v.id) {
        cartForm.style.display = 'block';
        vidInput.value = v.id;
      } else {
        cartForm.style.display = 'none';
      }
    }
  }
 

  function updateRightPanel() {
    var pr = PRODUCTS[currentModel];
    var te = document.getElementById('jdg-adapt-rp-title');
    if (te) te.textContent = pr.title + ' Collection';

    var fc = document.getElementById('jdg-adapt-feels');
    if (fc) {
      fc.innerHTML = '';
      pr.feels.forEach(function(f, i) {
        var b = document.createElement('button');
        b.className   = 'jdg-rp-opt' + (i === 0 ? ' selected' : '');
        b.textContent = f;
        b.onclick     = function() { selectFeel(f, b); };
        fc.appendChild(b);
      });
      currentFeel = pr.feels[0];
    }

    var sc = document.getElementById('jdg-adapt-sizes');
    if (sc) {
      var firstAvailable = null;
      sc.querySelectorAll('.jdg-size-btn').forEach(function(b) {
        var avail = pr.sizes.indexOf(b.dataset.size) !== -1;
        b.classList.toggle('disabled', !avail);
        b.classList.remove('selected');
        if (avail && !firstAvailable) firstAvailable = b.dataset.size;
      });
      var pick = pr.sizes.indexOf('Queen') !== -1 ? 'Queen' : firstAvailable;
      if (pick) {
        currentSize = pick;
        var pickBtn = sc.querySelector('.jdg-size-btn[data-size="' + pick + '"]');
        if (pickBtn) pickBtn.classList.add('selected');
      }
    }

    updatePrice();
    updateButtons();
  }

  function selectModel(m) {
    currentModel = m;
    document.querySelectorAll('.jdg-model-card').forEach(function(c) {
      c.classList.toggle('active', c.dataset.model === m);
    });
    document.querySelectorAll('.jdg-rp-opt[data-model]').forEach(function(o) {
      o.classList.toggle('selected', o.dataset.model === m);
    });
    updateRightPanel();
  }

  function selectSize(s, el) {
    if (el.classList.contains('disabled')) return;
    currentSize = s;
    document.querySelectorAll('.jdg-size-btn').forEach(function(b) { b.classList.remove('selected'); });
    el.classList.add('selected');
    updatePrice(); updateButtons();
  }

  function selectFeel(f, el) {
    currentFeel = f;
    document.querySelectorAll('#jdg-adapt-feels .jdg-rp-opt').forEach(function(b) { b.classList.remove('selected'); });
    el.classList.add('selected');
    updatePrice(); updateButtons();
  }

  window.jdgAdapt = { selectModel: selectModel, selectSize: selectSize, selectFeel: selectFeel };

  document.addEventListener('DOMContentLoaded', function() { updateRightPanel(); });

})();